import { render, staticRenderFns } from "./modal-draftAnimation.vue?vue&type=template&id=6e30aab5&"
import script from "./modal-draftAnimation.vue?vue&type=script&lang=ts&"
export * from "./modal-draftAnimation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports